import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { api } from '../lib/api'
import { KBEditorV2 } from '../components/kb/editor/KBEditorV2'

export default function KBArticleEditPage() {
  const { slug } = useParams<{ slug: string }>()
  const navigate = useNavigate()
  const [categories, setCategories] = useState<{ id: string; name: string }[]>([])

  useEffect(() => {
    api.get<{ id: string; name: string }[]>('/kb/categories')
      .then(cats => setCategories(Array.isArray(cats) ? cats : []))
      .catch(() => {})
  }, [])

  return (
    <KBEditorV2
      articleSlug={slug || null}
      categories={categories}
      onClose={() => navigate(slug ? `/kb/${slug}` : '/kb')}
      onSaved={() => {}}
    />
  )
}
